<cc-box>
  <div class="container-responsive" header box translate>
    PLANS.PHONE_NUMBER_PLAN
  </div>
  <div content box>
    <div class="center" *ngIf="!(msisdnsSubscriptions)?.length">
      <span class="text" translate>PLANS.YOUR_NUMBERS</span>
      <button mat-raised-button color="primary" (click)="buyNewNumber()">
        {{ 'PLANS.GET_NUMBER' | translate }}
      </button>
    </div>
    <div *ngIf="(msisdnsSubscriptions)?.length">
      <div class="table-wrapper">
        <table class="numbers-table">
          <thead>
          <tr>
            <th class="first-header" translate></th>
            <th translate></th>
            <th translate></th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let msisdn of msisdnsSubscriptions">
            <td class="msisdn-cell">
              <cc-msisdn [msisdn]="getClientMsisdn(msisdn)"></cc-msisdn>
            </td>

            <ng-container *ngIf="msisdn.source === 'CLIENT'; else channelsNumber">
              <td class="price-cell">{{'PRICE_CUSTOM' | translate}}</td>
            </ng-container>

            <ng-template #channelsNumber>
              <td class="price-cell" *ngIf="isFree(msisdn)">{{'PRICE_FREE' | translate}}</td>
              <td class="price-cell" *ngIf="!isFree(msisdn)">{{msisdn.price | currency}}</td>
            </ng-template>
            <td class="actions-cell">
              <a (click)="cancelNumberSubscription(msisdn)">
                <i class="fas fa-trash-alt"></i>
              </a>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <div class="right button-wrapper">
        <button mat-raised-button color="primary" (click)="buyNewNumber()">
          {{ 'PLANS.GET_NEW_NUMBER' | translate }}
        </button>
      </div>
    </div>
  </div>
</cc-box>
